import { useEffect, useState } from 'react'

export default function Lightbox({ images, startIndex, onClose }) {
  const [index, setIndex] = useState(startIndex)

  useEffect(() => {
    function handleKey(e) {
      if (e.key === 'Escape') onClose()
      if (e.key === 'ArrowRight') setIndex((i) => (i + 1) % images.length)
      if (e.key === 'ArrowLeft') setIndex((i) => (i - 1 + images.length) % images.length)
    }
    document.body.style.overflow = 'hidden'
    window.addEventListener('keydown', handleKey)
    return () => {
      document.body.style.overflow = ''
      window.removeEventListener('keydown', handleKey)
    }
  }, [images.length, onClose])

  if (!images?.length) return null

  return (
    <div className="lightbox-overlay" onClick={onClose}>
      <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
        <button className="lightbox-close" onClick={onClose} aria-label="Close">×</button>
        {images.length > 1 && (
          <button
            className="lightbox-arrow lightbox-arrow--left"
            onClick={() => setIndex((i) => (i - 1 + images.length) % images.length)}
            aria-label="Previous"
          >‹</button>
        )}
        <img className="lightbox-image" src={images[index].url?.replace(/^http:\/\//i, 'https://')} alt={`Photo ${index + 1}`} />
        {images.length > 1 && (
          <button
            className="lightbox-arrow lightbox-arrow--right"
            onClick={() => setIndex((i) => (i + 1) % images.length)}
            aria-label="Next"
          >›</button>
        )}
        {images.length > 1 && (
          <p className="lightbox-counter">{index + 1} / {images.length}</p>
        )}
      </div>
    </div>
  )
}
